import "../i18n.mjs";
import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
//#region src/hooks/useTrHomeRowTitle.ts
var n = () => {
	let { t: n } = t("properties");
	return e((e) => {
		switch (e.kind) {
			case "featured_listings": return e.params.header;
			case "destination": return n("home.rows.destination", { name: e.params.name });
			case "because_you_viewed": return n("home.rows.because_you_viewed", { title: e.params.title });
			case "back_to_destination": return n("home.rows.back_to_destination", { destination: e.params.search.destination_label });
			default: return n(`home.rows.${e.kind}`);
		}
	}, [n]);
};
//#endregion
export { n as useTrHomeRowTitle };
